import { Component, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-terms-and-conditions-mbl',
    templateUrl: './terms-and-conditions-mbl.component.html',
    styleUrls: ['./terms-and-conditions-mbl.component.css', './../landing/landing.component.css', '../security/security.component.css'],
    standalone: false
})
export class TermsAndConditionsMblComponent {
  @ViewChild('pricing') pricing;
  constructor(
    private modalService: NgbModal
  ) {}

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
}
